import React, { useState } from 'react'
import { Redirect, useHistory } from 'react-router'
import { toast } from 'react-toastify';
import '../../../../styles/smart_wizard_all.css'
import { currencyConvertor, isEclipseOpsTruck, showAlert } from '../../../../Utils/Utility';
import BilledHeader from './BilledHeader'
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';

function SelectPayment({ intl, ...props }) {
    const id = props.match.params.id;
    const { formatMessage } = intl;
    let check = ["Insta-Money", "Us-Bank"]
    let creditcard = ["Credit Card"]
    let Automated = ["Relay", "ComData", "EFS/WEX", "T-Chek"]
    const amount = props.location.state.totalremainingAmount ? props.location.state.totalremainingAmount : props.location.state.amount;
    const selection = props.location.state.selection;
    const total_bill_amount = props.location.state.total_bill_amount;
    const remainingAmount = props.location.state.remainingAmount;
    const { tin } = props.location.state;
    const [paymentmethods, setPaymentmethod] = useState("");
    const [methodSelection, setMethodSelection] = useState(true);
    const history = useHistory();
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id);
    let unload_bill_amount = currencyConvertor(load.unloading_bill_amount);
    const loadId = load.load_id;

    const handleChange = (e) => {

        if (e.target.id === "Credit Card") {
            setPaymentmethod("CreditCard")
            setMethodSelection(false);
        }
        else if (e.target.id === "Relay") {
            setPaymentmethod("Relay")
            setMethodSelection(false);
        }
        else if (e.target.id === "ComData") {
            setPaymentmethod("ComData")
            setMethodSelection(false);
        }
        else if (e.target.id === "Insta-Money") {
            setPaymentmethod("Insta-Money")
            setMethodSelection(false);
        }

        else if (e.target.id === "Us-Bank") {
            setPaymentmethod("Us-Bank")
            setMethodSelection(false);
        }

        else if (e.target.id === "EFS/WEX") {
            setPaymentmethod("EFS")
            setMethodSelection(false);
        }

        else if (e.target.id === "T-Chek") {
            setPaymentmethod("T-Chek")
            setMethodSelection(false);
        }
    }

    const handleClick = () => {

        if (isEclipseOpsTruck(load)) {
            paymentmethods && history.push({ pathname: `/paymentconfirmation/${id}`, state: { amount, paymentmethods, selection, remainingAmount, total_bill_amount } })
        }
        else {
            paymentmethods && history.push({ pathname: `/paymentconfirmation/${id}`, state: { amount, paymentmethods, selection, remainingAmount, total_bill_amount } })

            // paymentmethods && history.push({
            //     pathname: `/newpaymentdetails/${id}`,
            //     state: { unload_bill_amount, loadId, paymentmethods } // your data array of objects
            // })
        }

        return null;

    }
    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <div className="contest_preview">
                        <BilledHeader path={`/billedDetails/${id}`} />
                        <div className="container_block" style={{ padding: '40px' }}>
                            <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                                <div id="step-3" className="tab-pane" role="tabpanel" aria-labelledby="step-3">
                                    <section>
                                        <h4 className="mb-3 txtwhite">{formatMessage({ id: "app.bank_details" })}</h4>
                                        <p>{formatMessage({ id: "app.select_payment_method" })}</p>
                                        <fieldset className="fieldset mt-3">
                                            <legend className="legend_title">{formatMessage({ id: "app.automated" })}</legend>
                                            <div className="row">
                                                <div className="col-4">
                                                    <div className="checkbox-circle">
                                                        {Automated.map((item, index) => (
                                                            <label key={index}>
                                                                <input type="radio" name="Automated" className="payment-choose" onChange={handleChange} id={item} value={item} />{item}
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        ))}

                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset className="fieldset mt-3">
                                            <legend className="legend_title">{formatMessage({ id: "app.creditcard" })}</legend>
                                            <div className="row">
                                                <div className="col-4">
                                                    <div className="checkbox-circle">
                                                        {
                                                            creditcard.map((item, index) => (
                                                                <label className="active" key={index}>
                                                                    <input type="radio" name="Automated" className="payment-choose" id="Credit Card" value={item} onChange={handleChange} />{item}
                                                                    <span className="checkmark"></span>
                                                                </label>

                                                            ))
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        {
                                            !isEclipseOpsTruck(load) &&
                                            <fieldset className="fieldset mt-3">
                                                <legend className="legend_title">{formatMessage({ id: "app.check" })}</legend>
                                                <div className="row">
                                                    <div className="col-4">
                                                        <div className="checkbox-circle">
                                                            {
                                                                check.map((item, index) => (
                                                                    <label className="active" key={index}>
                                                                        <input type="radio" name="Automated" className="payment-choose" id={item} value={item} onChange={handleChange} />{item}
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                ))
                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>

                                        }

                                        <fieldset className="fieldset mt-3">
                                            <div className="row justify-content-center">
                                                <div className="col-12 d-flex justify-content-center">
                                                    <span style={{ fontWeight: 700 }}>{`${formatMessage({ id: "app.tin" })} - ${tin}`}</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </section>
                                </div>

                                <div
                                    className="toolbar toolbar-bottom"
                                    role="toolbar"
                                    style={{ textAlign: "right" }}
                                >
                                    <button type="button" className="btn sw-btn-next btn-chartreuse float-right text-center" onClick={handleClick} disabled={methodSelection}>{formatMessage({ id: "app.continue" })}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default injectIntl(SelectPayment);
